/* hgn-send-to-starter-kit.js — moved verbatim from snippets/hgn-send-to-starter-kit.liquid on 2026-09-14 (page-weight phase B:
   inline JS → theme asset, loaded synchronously at the same position so execution order and
   DOMContentLoaded timing are unchanged). 1 original <script> block(s), in order.
   EDIT THIS FILE, not the snippet. */

(function () {
  'use strict';

  if (window.HGN && window.HGN.sendToStarterKit) return;

  var STARTER_KIT_MINIMUMS = { classic: 5, gels: 3, 'press-ons': 3 };

  /* Worker endpoint. Defined here so it can be swapped easily if the
     deployment moves. */
  var DISCOUNT_API_URL = 'https://holygrailnail.co/api/bundle/create-discount';

  /* Display labels for the visible "Bundle" / "Box ID" line-item
     properties so cart + checkout group the items nicely. */
  var KIT_DISPLAY_LABEL = {
    classic:     'Classic Starter Kit',
    gels:        'Gel Starter Kit',
    'press-ons': 'Press-On Starter Kit'
  };

  /* product_type → tier — case-sensitive, mirrors the canonical mapping
     used across the redesigned theme. */
  function tierFromProductType(productType) {
    switch (String(productType || '').trim()) {
      /* 2026-09-08 (IR-1 probe): the live catalogue's 140 press-on
         products carry product_type "press on" and kids wraps carry
         "Mini Me (Kids Nail Wraps)" — neither matched, so every
         press-on basket classified as null and the side-cart kit
         upsell never fired for them. */
      case 'press on':
      case 'Press On':
      case 'Press Ons':
      case 'Soft Gel Press Ons':
      case 'press-ons':
        return 'press-ons';
      case 'Gel':
      case 'Crystal':
      case 'Semi-Cured Gels':
        return 'gels';
      case 'Standard Width':
      case 'Wide Fit':
      case 'Kids':
      case 'Mini Me (Kids Nail Wraps)':
      case 'Non-UV Nail Wraps':
        return 'classic';
      case 'Accessories':
      case 'Starter Kits':
        return 'accessories';
      default:
        return null;
    }
  }

  function getBundlePrice(kit) {
    var prices = window.HGN_KIT_BUNDLE_PRICES || {};
    var v = prices[kit];
    return (typeof v === 'number' && v > 0) ? v : null;
  }

  /* Pre-flight validation — pure check, no network. Returns ok:true or
     a reason. Callers (kit-bar drawer, etc.) use this to gate their
     Send button. */
  function canSendToStarterKit(payload) {
    payload = payload || {};
    var kit = payload.kit;
    var items = Array.isArray(payload.items) ? payload.items : [];

    var minimum = STARTER_KIT_MINIMUMS[kit];
    if (typeof minimum !== 'number') {
      return { ok: false, reason: 'unknown-kit', detail: kit };
    }

    if (items.length !== minimum) {
      return {
        ok: false,
        reason: 'wrong-count',
        detail: { kit: kit, required: minimum, got: items.length }
      };
    }

    var oos = items.filter(function (it) {
      return !it || it.available === false;
    });
    if (oos.length > 0) {
      return {
        ok: false,
        reason: 'has-oos',
        detail: { count: oos.length, items: oos }
      };
    }

    var bad = items.filter(function (it) {
      return !it || !/^\d+$/.test(String(it.id || ''));
    });
    if (bad.length > 0) {
      return {
        ok: false,
        reason: 'bad-ids',
        detail: { count: bad.length, items: bad }
      };
    }

    /* Defence-in-depth: refuse if any item looks like a starter kit. */
    var STARTER_KIT_RX = /(^|[\s\-_])starter[\s\-_]?kit(s)?(\b|[\s\-_])/i;
    var kitlike = items.filter(function (it) {
      if (!it) return false;
      if (STARTER_KIT_RX.test(String(it.handle || ''))) return true;
      if (STARTER_KIT_RX.test(String(it.title || ''))) return true;
      if (String(it.product_type || it.type || '') === 'Starter Kits') return true;
      return false;
    });
    if (kitlike.length > 0) {
      return {
        ok: false,
        reason: 'starter-kit-not-eligible',
        detail: { count: kitlike.length, items: kitlike }
      };
    }

    if (!getBundlePrice(kit)) {
      return { ok: false, reason: 'no-bundle-price', detail: kit };
    }

    return { ok: true };
  }

  /* Resolve variant ID + price (in pounds) for an item that only
     carries a handle. The worker needs both. The endpoint is browser-
     cacheable so repeated lookups within a session are cheap.

     Returns: { variantId, price, available } or null on failure. */
  function resolveProduct(item) {
    if (!item) return Promise.resolve(null);
    if (item.variantId && typeof item.price === 'number') {
      /* Already complete (accessories from HGN_KIT_ACCESSORIES). */
      return Promise.resolve({
        variantId: parseInt(item.variantId, 10),
        price: item.price,
        available: item.available !== false,
        title: item.title || ''
      });
    }
    if (!item.handle) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(item.handle) + '.js', {
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) return null;
      return res.json();
    }).then(function (product) {
      if (!product || !product.variants || !product.variants.length) return null;
      /* Prefer the first available variant; fall back to first overall
         so a fully OOS product still resolves (canSendToStarterKit's
         OOS check will refuse the send anyway). */
      var variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      return {
        variantId: parseInt(variant.id, 10),
        /* Shopify variant prices are in cents — convert to pounds. */
        price: variant.price / 100,
        available: product.available !== false && variant.available !== false,
        title: product.title || item.title || ''
      };
    }).catch(function () { return null; });
  }

  /* Live stock recheck — kept for legacy callers (kit-bar drawer
     reads this via window.HGN.verifyKitStock). Returns the items
     array with their `available` flag refreshed. */
  function verifyStock(items) {
    var withHandle = items.filter(function (it) { return it && it.handle; });
    if (withHandle.length === 0) return Promise.resolve(items);
    return Promise.all(withHandle.map(function (it) {
      return fetch('/products/' + encodeURIComponent(it.handle) + '.js', {
        credentials: 'same-origin'
      }).then(function (res) { return res.ok ? res.json() : null; })
        .then(function (product) {
          if (!product) return { item: it, available: it.available !== false };
          return { item: it, available: product.available !== false };
        }).catch(function () {
          return { item: it, available: it.available !== false };
        });
    })).then(function (results) {
      return items.map(function (it) {
        if (!it.handle) return it;
        for (var i = 0; i < results.length; i++) {
          if (results[i] && results[i].item === it) {
            return Object.assign({}, it, { available: results[i].available });
          }
        }
        return it;
      });
    });
  }

  /* Flatten the accessories object into an array of items the bundle
     needs. `accessories` can contain:
       - required slots:  topCoat / uvLamp / remover / giftBag
       - optional slots:  tabs / glue (press-ons)
     Each value is { id, variantId, handle, title, image, price }
     pre-resolved by the announcement-bar drawer from
     HGN_KIT_ACCESSORIES. */
  function flattenAccessories(accessories) {
    if (!accessories || typeof accessories !== 'object') return [];
    return Object.keys(accessories)
      .map(function (slot) { return accessories[slot]; })
      .filter(function (v) { return v && (v.variantId || v.id); });
  }

  /* sendToStarterKit — the main entry. Returns a Promise. The happy
     path redirects to /cart before the promise resolves; failure
     paths resolve with { ok: false, reason, detail }. */
  function sendToStarterKit(payload) {
    var check = canSendToStarterKit(payload);
    if (!check.ok) {
      if (window && window.console) {
        console.warn('[hgn-send-to-starter-kit] refused:', check.reason, check.detail);
      }
      return Promise.resolve(check);
    }

    var kit = payload.kit;
    var basePrice = getBundlePrice(kit);
    var primaryItems = payload.items.slice();
    var accessoryItems = flattenAccessories(payload.accessories);

    /* Optional upsells (press-on tabs / glue) carry an `uplift` £
       value — when selected they add to the base bundle price. Sum
       them all so the worker mints a discount targeting the higher
       price, not the base. Without this the upsells effectively
       become free because the discount brings retail down past the
       base bundle price. */
    var totalUplift = accessoryItems.reduce(function (sum, it) {
      var u = it && typeof it.uplift === 'number' ? it.uplift : 0;
      return sum + u;
    }, 0);
    var bundlePrice = Math.round((basePrice + totalUplift) * 100) / 100;
    if (totalUplift > 0 && window && window.console) {
      console.info('[hgn-send-to-starter-kit] bundle price',
        '£' + basePrice.toFixed(2), '+', '£' + totalUplift.toFixed(2),
        'uplift =', '£' + bundlePrice.toFixed(2));
    }

    /* Resolve every item in parallel — fetches /products/<handle>.js
       for primaries (which carry a handle but no variantId/price),
       passes accessories through (they already have variantId+price
       from the section settings). */
    var primaryResolves = primaryItems.map(resolveProduct);
    var accessoryResolves = accessoryItems.map(resolveProduct);

    return Promise.all(primaryResolves.concat(accessoryResolves))
      .then(function (resolved) {
        /* Bail if any item failed to resolve — we can't price the
           bundle without knowing every variant's retail. */
        var missing = [];
        resolved.forEach(function (r, idx) {
          if (!r) missing.push(idx);
        });
        if (missing.length) {
          return {
            ok: false,
            reason: 'resolve-failed',
            detail: { missing: missing }
          };
        }

        /* Live stock recheck — defensive against picks that went OOS
           between selection and send. */
        var nowOos = resolved.filter(function (r) { return !r.available; });
        if (nowOos.length) {
          /* Map back to original items so the caller can mark them. */
          var oosOriginals = [];
          resolved.forEach(function (r, idx) {
            if (!r.available) {
              var src = idx < primaryItems.length
                ? primaryItems[idx]
                : accessoryItems[idx - primaryItems.length];
              oosOriginals.push(Object.assign({}, src, { available: false }));
            }
          });
          if (window && window.console) {
            console.warn('[hgn-send-to-starter-kit] live stock recheck failed:',
              oosOriginals.map(function (it) { return it.id || '?'; }).join(', '));
          }
          return {
            ok: false,
            reason: 'now-oos',
            detail: { count: oosOriginals.length, items: oosOriginals }
          };
        }

        /* Step 1 — REMOVED. Mint-at-checkout architecture: no worker
           call here. The consolidated cart discount (covering kit
           savings + any free gift retail) is minted ONLY when the
           shopper hits Checkout in the side cart, via
           POST /api/cart-discount/create. Until then the bundle
           lines sit on the cart at full retail with the target
           price stamped on each line as `_bundle_price_cents` —
           the side cart's `_computeTotalSavings` reads that to
           render the discounted "what you'll pay" view. */
        return Promise.resolve().then(function () {
          /* Step 2 — add every item to the Shopify cart with bundle
             line-item properties grouping them. We use a UUID-ish
             bundle id so multiple bundles in one cart can be told
             apart. `_bundle_price_cents` is the bundle's target total
             (basePrice + uplifts) — side cart distributes savings
             from this against retail. */
          var bundleId = 'box-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);
          var displayLabel = KIT_DISPLAY_LABEL[kit] || 'Starter Kit';
          var bundlePriceCents = Math.round(bundlePrice * 100);
          var cartItems = resolved.map(function (r) {
            return {
              id: r.variantId,
              quantity: 1,
              properties: {
                '_bundle_type':         kit + '-starter-kit',
                '_bundle_id':           bundleId,
                '_bundle_price_cents':  String(bundlePriceCents),
                'Bundle':               displayLabel,
                'Box ID':               bundleId
              }
            };
          });

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: cartItems })
          }).then(function (res) {
            return res.json().then(function (body) {
              return { ok: res.ok, status: res.status, body: body };
            });
          }).then(function (cartResp) {
            if (!cartResp.ok) {
              if (window && window.console) {
                console.warn('[hgn-send-to-starter-kit] cart-add failed:',
                  cartResp.status, cartResp.body);
              }
              return {
                ok: false,
                reason: 'cart-add-failed',
                detail: cartResp.body
              };
            }

            /* Step 3 — REMOVED. No discount code exists yet under the
               mint-at-checkout flow. The bundle's target price is on
               the line as `_bundle_price_cents`; the consolidated
               cart discount gets minted + applied by the side cart's
               checkout button just before redirecting to /checkout. */
            return Promise.resolve({ ok: true }).then(function (discountResp) {

              /* Step 4 — clear the kit from kitProgress. The drawer's
                 subscribe re-renders, hides the announcement bar, and
                 the shopper can start a fresh kit if they like. */
              try {
                if (window.HGN && window.HGN.kitProgress &&
                    typeof window.HGN.kitProgress.clearKit === 'function') {
                  window.HGN.kitProgress.clearKit(kit);
                }
              } catch (e) {}

              /* Step 5 — refresh the cart, broadcast cart-update with
                 the fresh cart, then open the side cart.
                 The cart drawer's first-add-empty bug is caused by
                 the drawer reading from a stale cached cart object —
                 it opens BEFORE our cart-add result has propagated.
                 We pre-fetch /cart.js so the cart cache is warm, then
                 dispatch a wide net of `cart:update` / `cart-update`
                 / `cart:change` events with the cart object attached
                 so any listener (Dawn-style theme.pubsub, vanilla
                 event listeners, web-component drawers) can pick up
                 the fresh state. Only THEN do we trigger the open
                 events so the drawer renders against the new cart.

                 The fetch uses `?sections=cart-drawer,cart-notification,
                 cart-icon-bubble` — Shopify's Section Rendering API
                 — so themes that swap section HTML on cart updates
                 get the pre-rendered markup and render correctly on
                 first open. Themes that don't use section rendering
                 still get the cart object via the event detail. */
              return fetch('/cart.js?sections=cart-drawer,cart-notification,cart-icon-bubble', {
                credentials: 'same-origin',
                headers: { 'Accept': 'application/json' }
              }).then(function (r) {
                return r.ok ? r.json() : null;
              }).catch(function () { return null; }).then(function (cart) {
                /* Broadcast the cart update so listeners can refresh
                   their local state. Use both `cart` and { cart }
                   payload shapes since themes vary. */
                try {
                  ['cart:update', 'cart-update', 'cart:change',
                   'cart:refresh', 'cart-drawer:refresh'].forEach(function (evt) {
                    document.dispatchEvent(new CustomEvent(evt, {
                      detail: cart ? { cart: cart, source: 'hgn-kit-bar' } : { source: 'hgn-kit-bar' },
                      bubbles: true
                    }));
                  });
                  if (window.theme && window.theme.pubsub &&
                      typeof window.theme.pubsub.publish === 'function') {
                    /* Dawn pattern. */
                    window.theme.pubsub.publish('cart-update', { source: 'hgn-kit-bar', cartData: cart });
                  }
                } catch (e) {}

                /* Render swap for Section-Rendering-API themes (Dawn
                   et al). When the response includes a sections.cart-drawer
                   HTML blob, we swap the corresponding element's
                   innerHTML so the drawer reflects the new cart on
                   first open. */
                if (cart && cart.sections && typeof cart.sections === 'object') {
                  try {
                    Object.keys(cart.sections).forEach(function (sectionId) {
                      var html = cart.sections[sectionId];
                      if (typeof html !== 'string' || !html) return;
                      /* Find the section root by id OR by section-tag.
                         Dawn uses `<cart-drawer>` (custom element)
                         which is also the section root. */
                      var candidates = [
                        document.getElementById(sectionId),
                        document.getElementById('shopify-section-' + sectionId),
                        document.querySelector(sectionId) // tag-name fallback
                      ].filter(Boolean);
                      if (candidates.length === 0) return;
                      var parser = new DOMParser();
                      var doc = parser.parseFromString(html, 'text/html');
                      var newRoot = doc.getElementById(sectionId) ||
                                    doc.querySelector(sectionId);
                      if (newRoot) {
                        candidates[0].innerHTML = newRoot.innerHTML;
                      }
                    });
                  } catch (e) {}
                }

                /* Tiny delay so any listener that just received
                   `cart:update` can finish its render before we tell
                   the drawer to open. */
                setTimeout(function () {
                  try {
                    ['cart:open', 'cart-drawer:open',
                     'dispatch:cart-drawer:open', 'on:cart-drawer:open']
                      .forEach(function (evt) {
                        document.dispatchEvent(new CustomEvent(evt, { bubbles: true }));
                      });
                    ['cart-drawer', 'cart-notification', 'side-cart',
                     'quick-cart', 'shopify-cart-drawer'].forEach(function (sel) {
                      document.querySelectorAll(sel).forEach(function (el) {
                        try {
                          if (typeof el.open === 'function') el.open();
                          el.classList.add('is-active', 'active', 'drawer--active', 'cart-drawer--active', 'open');
                          el.removeAttribute('hidden');
                          el.setAttribute('open', '');
                          el.setAttribute('aria-hidden', 'false');
                        } catch (e) {}
                      });
                    });
                    if (window.theme && window.theme.pubsub &&
                        typeof window.theme.pubsub.publish === 'function') {
                      window.theme.pubsub.publish('cart:open');
                    }
                    if (window.theme && window.theme.CartDrawer &&
                        typeof window.theme.CartDrawer.open === 'function') {
                      window.theme.CartDrawer.open();
                    }
                  } catch (e) {}
                }, 80);

                return {
                  ok: true,
                  discountCode: discountCode,
                  bundleId: bundleId,
                  discountApplied: !!discountResp.ok,
                  cart: cart
                };
              });
            });
          });
        });
      })
      .catch(function (err) {
        if (window && window.console) {
          console.warn('[hgn-send-to-starter-kit] threw:', err);
        }
        return { ok: false, reason: 'exception', detail: String(err) };
      });
  }

  window.HGN = window.HGN || {};
  window.HGN.STARTER_KIT_MINIMUMS = STARTER_KIT_MINIMUMS;
  window.HGN.tierFromProductType  = tierFromProductType;
  window.HGN.canSendToStarterKit  = canSendToStarterKit;
  window.HGN.sendToStarterKit     = sendToStarterKit;
  window.HGN.verifyKitStock       = verifyStock;
})();
